import { render, staticRenderFns } from "./NearbySection.vue?vue&type=template&id=3adddc7b&"
import script from "./NearbySection.vue?vue&type=script&lang=js&"
export * from "./NearbySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3adddc7b')) {
      api.createRecord('3adddc7b', component.options)
    } else {
      api.reload('3adddc7b', component.options)
    }
    module.hot.accept("./NearbySection.vue?vue&type=template&id=3adddc7b&", function () {
      api.rerender('3adddc7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/NearbySection.vue"
export default component.exports